import { render, staticRenderFns } from "./TuckToggle.vue?vue&type=template&id=58bee7d6&scoped=true&"
import script from "./TuckToggle.vue?vue&type=script&lang=ts&"
export * from "./TuckToggle.vue?vue&type=script&lang=ts&"
import style0 from "./TuckToggle.vue?vue&type=style&index=0&id=58bee7d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bee7d6",
  null
  
)

export default component.exports